import { Icon } from '../Icon/Icon';

export const Loader: FC = ({ className }) => {
    return <Icon icon="Spinner" iconType="icon" className={className} />;
};
